<div fxFlex="80" fxFlexOffset="10">
  <div class="toto">
    <h2 class="title-CVM">Upload and Download Xlsx Files</h2>
    @if (importFileXlsxes.length !== 0) { @for (function of importFileXlsxes; track function.id) {
    <div>
      <mic-app-import-file-xlsx [xlsxFunction]="function"></mic-app-import-file-xlsx>
    </div>
    } } @else {
    <mic-empty-state icon="layers_clear" title="There is no Function to display."> </mic-empty-state>
    }
  </div>
</div>
